var _path, _path2, _polygon, _polygon2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaleoLogoPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 518 140",
    fill: "#2E1B42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.6,16.8H11v112.6h19.7V87.2h29.9c23.5,0,36.6-16,36.6-35.1C97.3,32.8,84.3,16.8,60.6,16.8z M57.9,69.8 H30.7V34.2h27.2c11.1,0,19.1,7.1,19.1,17.9C77,62.7,69.1,69.8,57.9,69.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.7,16.8L89.5,129.4H112l8.3-21.8h51.7l8.3,21.8h22.5L158.4,16.8H133.7z M125.8,90.2l20.3-53.7l20.3,53.7 H125.8z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "233.2,16.8 213.4,16.8 213.4,129.4 282.8,129.4 282.8,112 233.2,112 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "300.2,129.4 377.4,129.4 377.4,112 319.9,112 319.9,80.6 376.2,80.6 376.2,63.2 319.9,63.2  319.9,34.2 377.4,34.2 377.4,16.8 300.2,16.8 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M450.3,14.9c-33.8,0-57.6,24.6-57.6,58.2c0,33.6,23.8,58.2,57.6,58.2c33.6,0,57.6-24.7,57.6-58.2 C507.8,39.6,483.9,14.9,450.3,14.9z M450.3,113.9c-22.8,0-37.3-17.6-37.3-40.7c0-23.3,14.5-40.7,37.3-40.7 c22.6,0,37.3,17.4,37.3,40.7C487.6,96.3,472.9,113.9,450.3,113.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaleoLogoPurple);
export default __webpack_public_path__ + "static/media/paleo-logo-purple.118b3611c93e0e3a46816e60d2b92963.svg";
export { ForwardRef as ReactComponent };